const initialState = {
  fetching: false,
  fetched: false,
  ranking: null,
  error: null,
  nbResult: 0,
};

export const organizationScoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INITIALIZE_ORGANIZATION_SCORE': {
      return initialState;
    }
    case 'FETCH_ORGANIZATION_SCORE_PENDING': {
      return { ...state, fetching: true };
    }
    case 'FETCH_ORGANIZATION_SCORE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        ranking: action.payload.data.data,
      };
    }
    case 'FETCH_ORGANIZATION_SCORE_REJECTED': {
      let error = action.payload;
      switch (error.response?.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404,
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error,
      };
    }
    default:
      return state;
  }
};
